import { reduce } from "et3-type-guards";
import React from "react";
import { useLocation } from "react-router-dom";
import i18n from "../../../constants/i18n";
import Et3PageTitle from "../../../core/et3-page-title/index";
import Et3Margin from "../../../core/et3-ui/ET3Margin";
import getAuditedEventsStore from "../../../stores/auditor-store/audited-events-store";
import getCoreHistoryStore from "../../../stores/core/core-history-store";
import getCorePopUpStore from "../../../stores/core/core-popup-store";
import AuditedEventsData from "./audited-events-data";
import AuditedEventsForm from "./audited-events-form";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import ET3PageDiv from "../../../core/et3-page-div";

const AuditedEvents = withLiteObserverAndTheme(() => {
  const location = useLocation();
  React.useEffect(() => {
    const search = reduce(() => location.search, "");
    getCoreHistoryStore().setPageName(
      "AUDITOR_AUDITED_EVENTS",
      "AUDITOR_AUDITED_EVENTS"
    );
    getAuditedEventsStore().checkURLSearch(search);
  }, []);

  return (
    <ET3PageDiv
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      style={{}}
    >
      <Et3PageTitle
        title={i18n.get("ADMIN")}
        subTitle={i18n.get("VIEW_ADMIN_AUDITED_EVENTS")}
        withRefresh={false}
        withHelper={true}
        onPress={() => {
          getCorePopUpStore().showHelperMessage(
            "Admin_Audit_Events_Helper_Text"
          );
        }}
      />
      <AuditedEventsForm />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <AuditedEventsData />
    </ET3PageDiv>
  );
});
export default AuditedEvents;
